import React from 'react';

const PiscesIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 20C5 35 5 65 20 80" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M80 20C95 35 95 65 80 80" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 50H80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default PiscesIcon;
